import { EMcweb, EPage } from '@/shared/enum/page.enum'
import type { RouteRecordRaw } from 'vue-router'
import { ROUTES_GUARDS } from '../mce/guards'

export const routesMcweb: RouteRecordRaw[] = [
  {
    path: '/maintenance',
    component: () => import('@/maintenance/pages/MaintenancePage.vue'),
    name: EPage.MAINTENANCE
  },
  {
    path: '/',
    component: () => import('@/components/layouts/McwLayout.vue'),
    redirect: '/',
    children: [
      {
        path: '',
        name: EPage.BLANK,
        component: () => import('@/blank/BlankPage.vue'),
        beforeEnter: ROUTES_GUARDS[EPage.BLANK]
      },
      {
        path: 'mcw',
        name: EMcweb.MCW,
        component: () => import('@/mcw/invoice/pages/McwInvoicePage.vue')
      },
      {
        path: 'result/:folio',
        name: EMcweb.OK_RESULT,
        component: () => import('@/result/pages/ResultPage.vue')
      },
      {
        path: 'genericError',
        name: EPage.GENERIC_ERROR,
        component: () => import('@/generic-error/pages/GenericErrorPage.vue')
      },
      {
        path: 'mcw/terms',
        name: EMcweb.MCW_TERMS,
        component: () => import('@/terms/pages/TermsPage.vue')
      },
      {
        path: ':pathMatch(.*)*',
        name: EPage.NOT_FOUND,
        component: () => import('@/not-found/pages/NotFoundPage.vue')
      }
    ]
  }
]
